import packageInfo from '../../package.json';

export const UNKNOWN_APP_VERSION = 'unknown';
export const WEB_APP_VERSION = packageInfo.version;

export const normalizeAppVersion = (version: string | null | undefined): string => {
  const trimmedVersion = version?.trim();

  if (!trimmedVersion) return UNKNOWN_APP_VERSION;

  const segments = trimmedVersion.split('.').filter(Boolean);

  while (segments.length > 2 && segments.at(-1) === '0') {
    segments.pop();
  }

  return segments.join('.') || UNKNOWN_APP_VERSION;
};
